import React, { useState } from 'react';
import { Car, ImageOff } from 'lucide-react';

const CarThumbnail = ({ imageUrl, title, className = "" }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  // Placeholder con gradiente y icono de auto
  const PlaceholderImage = () => (
    <div className="car-thumbnail-container bg-gradient-to-br from-dark-accent via-dark-secondary to-dark-card flex items-center justify-center relative">
      {/* Efecto de brillo animado */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent "></div>
      
      {/* Icono principal */}
      <div className="relative z-10 flex flex-col items-center space-y-2">
        <div className="p-4 bg-dark-text/20 rounded-full">
          <Car className="w-8 h-8 text-[#7b8fa8]" />
        </div>
        <span className="text-xs text-gray-400 text-center px-2">
          {imageError ? 'Imagen no disponible' : 'Cargando...'}
        </span>
      </div>
      
      {/* Efectos decorativos */}
      <div className="absolute top-2 right-2 w-2 h-2 bg-dark-text/30 rounded-full"></div>
      <div className="absolute bottom-2 left-2 w-3 h-3 bg-purple-500/20 rounded-full"></div>
    </div>
  );

  return (
    <div className={`relative car-thumbnail-container bg-[#232321] ${className}`}>
      {/* Imagen real */}
      {imageUrl && !imageError && (
        <img
          src={imageUrl}
          alt={title}
          className={`car-thumbnail w-full h-full transition-all duration-500 ${
            imageLoaded ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
          }`}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
      )}
      
      {/* Placeholder */}
      {(!imageUrl || imageError || !imageLoaded) && (
        <div className={`absolute inset-0 transition-opacity duration-500 ${
          imageLoaded && !imageError ? 'opacity-0' : 'opacity-100'
        }`}>
          <PlaceholderImage />
        </div>
      )}
      
      {/* Overlay con gradiente */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
      
      {/* Indicador de carga */}
      {imageUrl && !imageLoaded && !imageError && (
        <div className="absolute top-2 right-2">
          <div className="w-4 h-4 border-2 border-dark-text/30 border-t-dark-text rounded-full animate-spin"></div>
        </div>
      )}
      
      {/* Efecto de hover */}
      <div className="absolute inset-0 bg-dark-text/5 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
    </div>
  );
};

export default CarThumbnail;
